<template>
  <Header />
  <SearchBar
    :title="$t('Claim filters')"
    :placeholder="$t('SearchClaims')"
    :current-page="currentPage"
    :available-filters="availableFilters"
    :selected-filters="selectedFilters"
    :initial-keywords="keywords"
    @updateFilterSearch="updateFilterSearch"
    @updateKeywordSearch="updateKeywordSearch"
    class="my-4"
  />
  <div class="mt-10">
    <Loading v-if="loading" />
    <div v-else-if="claims.length === 0" class="text-center mt-4 py-2">
      <p>Aucun sinistre</p>
    </div>
    <PaginatedClaimList
      v-else
      :total-count="totalCount"
      :total-pages="totalPages"
      :current-page="currentPage"
      :claims="claims"
      @changePage="handleChangePage"
      @redirectToClaimDetailsPage="redirectToClaimDetailsPage"
    />
  </div>
</template>

<script>
import PaginatedClaimList from "@/components/claim/list/PaginatedClaimList.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import SearchBar from "@/components/menu/SearchBar.vue";
import Header from "@/views/store/claim/Header.vue";
import { Loading } from "@estaly/ui";

export default {
  components: {
    Header,
    SearchBar,
    PaginatedClaimList,
    Loading,
  },

  data() {
    return {
      currentPage: 1,
      loading: true,
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapGetters("claimList", ["getClaims"]),
    ...mapState("claimList", ["claims", "totalCount", "totalPages", "availableFilters", "selectedFilters", "keywords"]),
  },

  methods: {
    ...mapActions("claimList", ["fetchClaims", "updateFilter", "updateSearch", "restrictStore"]),

    handleChangePage: function (page) {
      this.currentPage = page;
    },

    redirectToClaimDetailsPage: function (claimId) {
      this.$router.push(`/platform/claim/${claimId}`);
    },

    async reloadClaims() {
      this.loading = true;
      await this.fetchClaims({ page: this.currentPage });
      this.loading = false;
    },

    updateFilterSearch: function (filterName, filterOptions) {
      this.updatePage(1, false);
      this.updateFilter({
        filterName: filterName,
        filterOptions: filterOptions,
        page: this.currentPage,
      });
    },

    updateKeywordSearch: function (keyword) {
      this.updatePage(1, false);
      this.updateSearch({
        searchString: keyword,
        page: this.currentPage,
      });
    },

    updatePage: function (newPage, refreshClaims = true) {
      this.currentPage = newPage;

      if (refreshClaims) {
        this.reloadClaims();
      }
    },
  },

  watch: {
    currentPage() {
      this.reloadClaims();
    },
    selectedStoreId(newSelectedStoreId) {
      if (newSelectedStoreId !== 0) {
        this.restrictStore(newSelectedStoreId);
        this.reloadClaims();
      }
    },
  },

  beforeMount() {
    this.restrictStore(this.selectedStoreId);
    this.reloadClaims();
  },
};
</script>
